import Lottie from 'lottie-react';
import { default as styled } from 'styled-components';

export const AnimationContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const LottieStyled = styled(Lottie)`
  width: 254px;
  height: 180px;
`;
